import { useTranslation } from '@framework/i18n';
import { Space, Typography } from 'antd';
import styled from 'styled-components';
import { SharedResourceFileList } from './components/SharedResourceFileList';
import { SharedResourceMetadataTable } from './components/SharedResourceMetadataTable';
import type { SharedResourceDocument } from './sharedResourceTypes';

const Section = styled.section`
  margin-top: 32px;
`;

export interface SharedResourceContentProps {
  maskedId: string;
  data: SharedResourceDocument;
}

export function SharedResourceContent(props: SharedResourceContentProps) {
  const { maskedId, data } = props;
  const { t } = useTranslation();

  const metadata = data.metadata ?? [];
  const files = data.files ?? [];

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <div>
        <Typography.Title level={2} style={{ marginBottom: 4 }}>
          {t('shared-resource.page-title', 'Informazioni del documento')}
        </Typography.Title>
        {data.resourceName && (
          <Typography.Title level={4} type="secondary" style={{ marginTop: 0 }}>
            {data.resourceName}
          </Typography.Title>
        )}
        <Typography.Text
          type="secondary"
          style={{ fontSize: 13, wordBreak: 'break-all' }}
        >
          {t('shared-resource.document-id', 'ID documento')}: {maskedId}
        </Typography.Text>
      </div>

      {metadata.length > 0 && (
        <Section aria-label={t('shared-resource.metadata', 'Metadati')}>
          <Typography.Title level={3}>
            {t('shared-resource.metadata', 'Metadati')}
          </Typography.Title>
          <SharedResourceMetadataTable items={metadata} />
        </Section>
      )}

      <Section aria-label={t('shared-resource.files', 'File allegati')}>
        <Typography.Title level={3}>
          {t('shared-resource.files', 'File allegati')}
        </Typography.Title>
        <SharedResourceFileList maskedId={maskedId} files={files} />
      </Section>
    </Space>
  );
}
